module.exports = __webpack_public_path__ + "img/myOn.df15af51.png";